// extracted by mini-css-extract-plugin
module.exports = {"uploadVideosForm":"UploadVideos_uploadVideosForm__21ztK","videoContainer":"UploadVideos_videoContainer__EYuxq","optionsContainer":"UploadVideos_optionsContainer__1atun"};